import { graphql } from '@/gql';

export const UserDoc = graphql(/* GraphQL */ `
  query User($id: ID!) {
    user(id: $id) {
      id
      email
      firstName
      lastName
      type
      status
      marketingOptIn
      marketingOptInAt
      emailBouncedAt
      pointsBalance
      visitCount
      spendCents
      tipCents
      lastVisitAt
      roleBindings {
        role {
          id
          name
          slug
        }
        scope {
          id
          name
        }
      }
      defaultPage
      defaultScope {
        id
        name
      }
      allowedScopes {
        id
        name
      }
      passkeys {
        id
        deviceType
        createdAt
        lastUsedAt
      }
      lastLoginAt
      goldenTicket {
        id
        userId
        holderName
        holderEmail
        status
        assignedAt
        note
        profileComplete
      }
      personal {
        lastName
        dateOfBirth
        dateOfBirthUpdatedAt
        phone
        address
        postalCode
        city
        country
        gender
        pronouns
      }
      business {
        iban
        chamberOfCommerce
        vatNumber
        invoiceEmail
      }
    }
  }
`);

export const UserLoyaltyDoc = graphql(/* GraphQL */ `
  query UserLoyalty($userId: UUID!) {
    userLoyalty(userId: $userId) {
      userId
      pointsBalance
      visitCount
      spendCents
      tipCents
      lastVisitAt
      recentLedger {
        id
        points
        reason
        note
        createdAt
        paymentId
        refundId
        orderId
        scope {
          id
          name
        }
      }
      vouchers {
        id
        status
        discountType
        discountPercentage
        discountAmountCents
        productName
        label
        ruleName
        issuedAt
        expiresAt
        scope {
          id
          name
        }
      }
    }
  }
`);

export const UserGoldenTicketsDoc = graphql(/* GraphQL */ `
  query UserGoldenTickets($filter: GoldenTicketFilter) {
    goldenTickets(filter: $filter, page: 1, pageSize: 25) {
      nodes {
        id
        userId
        holderName
        holderEmail
        status
        assignedAt
        note
        profileComplete
      }
    }
  }
`);

export const UserRolesCatalogDoc = graphql(/* GraphQL */ `
  query UserRolesCatalog {
    roles(actorKind: USER) {
      id
      name
      slug
    }
  }
`);

export const UserRoleOptionsDoc = graphql(/* GraphQL */ `
  query UserRoleOptions {
    userRoleOptions {
      id
      name
      slug
    }
  }
`);

export const SetUserRolesDoc = graphql(/* GraphQL */ `
  mutation SetUserRoles($userId: UUID!, $bindings: [RoleBindingInput!]!) {
    setUserRoles(userId: $userId, bindings: $bindings) {
      id
      roleBindings {
        role {
          id
          name
        }
        scope {
          id
          name
        }
      }
    }
  }
`);

export const CreateUserDoc = graphql(/* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      email
    }
  }
`);

export const UpdateUserDoc = graphql(/* GraphQL */ `
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      email
      firstName
      lastName
      type
      personal {
        dateOfBirth
        phone
      }
      business {
        iban
      }
    }
  }
`);

export const BlockUserDoc = graphql(/* GraphQL */ `
  mutation BlockUser($id: UUID!) {
    blockUser(id: $id) {
      id
      status
    }
  }
`);

export const UnblockUserDoc = graphql(/* GraphQL */ `
  mutation UnblockUser($id: UUID!) {
    unblockUser(id: $id) {
      id
      status
    }
  }
`);

export const IssueMagicLinkDoc = graphql(/* GraphQL */ `
  mutation IssueMagicLink($userId: ID!) {
    issueMagicLink(userId: $userId) {
      url
      qrSvg
      expiresAt
    }
  }
`);

export const AdjustUserPointsDoc = graphql(/* GraphQL */ `
  mutation AdjustUserPoints($input: AdjustUserPointsInput!) {
    adjustUserPoints(input: $input) {
      userId
      pointsBalance
      visitCount
      spendCents
      tipCents
      lastVisitAt
    }
  }
`);

export const AssignGoldenTicketDoc = graphql(/* GraphQL */ `
  mutation AssignGoldenTicket($userId: UUID!, $note: String) {
    assignGoldenTicket(userId: $userId, note: $note) {
      id
      status
      assignedAt
    }
  }
`);

export const RevokeGoldenTicketDoc = graphql(/* GraphQL */ `
  mutation RevokeGoldenTicket($id: UUID!, $note: String) {
    revokeGoldenTicket(id: $id, note: $note) {
      id
      status
      revokedAt
    }
  }
`);

export const CreatePasskeyRegistrationLinkDoc = graphql(/* GraphQL */ `
  mutation CreatePasskeyRegistrationLink($userId: ID!) {
    createPasskeyRegistrationLink(userId: $userId) {
      url
      qrSvg
      expiresAt
    }
  }
`);

export const RevokePasskeyDoc = graphql(/* GraphQL */ `
  mutation RevokePasskey($id: ID!) {
    revokePasskey(id: $id) {
      id
      revokedAt
    }
  }
`);
